import React, { useContext } from 'react';
import { areProgramMetadataValid } from '@24i/player-utils';
import { PlayerUIContext, formatTimeText } from '@24i/player-ui';
import { usePlayerTimes } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { Time } from '../PlayerUI/RegularView/components/PlayerFooter/styled';
export const ElapsedTime = ({ playerInstance, programRange, showHours, className, style, }) => {
    var _a, _b, _c;
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    const timeFormat = (_a = useFeature('localization')) === null || _a === void 0 ? void 0 : _a.timeFormat;
    const { elapsedTime, loadedMetadata } = usePlayerTimes(playerInstance);
    let milliseconds = elapsedTime;
    if (isLive && playerInstance) {
        const { programStart, programEnd } = playerInstance.getMetadata();
        const rangeStart = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _b !== void 0 ? _b : programStart;
        const rangeEnd = (_c = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _c !== void 0 ? _c : programEnd;
        const timestamp = playerInstance.getUTCTimestamp(milliseconds);
        if (areProgramMetadataValid(rangeStart, rangeEnd)) {
            milliseconds = rangeStart;
        }
        else if (timestamp) {
            milliseconds = timestamp.getTime();
        }
        else if (playerInstance.timeshiftRange) {
            milliseconds = Date.now() - (playerInstance.timeshiftRange.end - elapsedTime);
        }
    }
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    const { theme } = useTheme();
    const timeString = formatTimeText(milliseconds, {
        loadedMetadata,
        isLive,
        showHours,
        timeFormat,
    });
    return (React.createElement(Time, { "data-test": "ElapsedTime-Time", testID: "elapsed_time", className: `ElapsedTime-Time ${className}`, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme, isVolumeOpened }, timeString));
};
ElapsedTime.defaultProps = {
    showHours: true,
    className: '',
    style: null,
};
//# sourceMappingURL=index.js.map